document.addEventListener('DOMContentLoaded', function () {

  // Mobile nav toggle
  var burger = document.querySelector('.burger');
  var mobileNav = document.querySelector('.mobile-nav');
  if (burger && mobileNav) {
    burger.addEventListener('click', function () {
      mobileNav.classList.toggle('is-open');
    });
  }

  // Buy Now: add to cart via AJAX, then redirect straight to checkout
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.buy-now');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    btn.disabled = true;
    btn.classList.add('is-loading');
    var originalText = btn.textContent;
    btn.textContent = 'Please wait...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Could not add to cart');
        return res.json();
      })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
        btn.textContent = originalText;
        alert('Sorry, this item could not be added to your cart. Please try again.');
      });
  });

});
